import { createContext, useContext, useState } from "react";

const BarNotificationContext = createContext();

export const BarNotificationProvider = ({ children }) => {
	const [notificationMessage, setNotificationMessage] = useState("");

	const value = {
		notificationMessage,
		setNotificationMessage,
	};

	return (
		<BarNotificationContext.Provider value={value}>
			{children}
		</BarNotificationContext.Provider>
	);
};

export const useBarNotification = () => useContext(BarNotificationContext);
